import(/* webpackMode: "eager", webpackExports: ["CategoryContainer"] */ "/app/packages/website/src/components/containers/category-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/website/src/context/category-page-context-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTagTrackingService"] */ "/app/packages/website/src/services/tracking/gtag-tracking.service.ts");
;
import(/* webpackMode: "eager", webpackExports: ["OWTrackingService"] */ "/app/packages/website/src/services/tracking/ow-tracking.service.ts");
